import type { Setter } from "solid-js";

import type { Page } from "../types";
import { useApi } from "../util/api";

type MenuProps = {
    page: Page;
    setPage: Setter<Page>;
};

export function Menu(props: MenuProps) {
    const api = useApi();

    const clickMenu = (page: Page) => (ev: Event) => {
        ev.preventDefault();
        ev.stopPropagation();
        props.setPage(page);
    };
    const disconnect = async (ev: Event) => {
        ev.preventDefault();
        ev.stopPropagation();
        await api.disconnect();
    };

    return <section id="admin-menu">
        <div>
            <ul>
                <li><a href="#"
                    classList={{ active: props.page === "home" }}
                    onClick={clickMenu("home")}>Accueil</a></li>
                <hr/>
                <li><a href="#"
                    classList={{ active: props.page === "dates" }}
                    onClick={clickMenu("dates")}>Dates</a></li>
                <li><a href="#"
                    classList={{ active: props.page === "videos" }}
                    onClick={clickMenu("videos")}>Vidéos</a></li>
                <hr/>
                <li><a href="#"
                    classList={{ active: props.page === "lyrics"}}
                    onClick={clickMenu("lyrics")}>Paroles</a></li>
                <li><a href="#"
                    classList={{ active: props.page === "disks"}}
                    onClick={clickMenu("disks")}>Albums</a></li>
                <li><a href="#"
                    classList={{ active: props.page === "tracks"}}
                    onClick={clickMenu("tracks")}>Pistes</a></li>
                <hr/>
                <li><a href="#"
                    classList={{ active: props.page === "contacts"}}
                    onClick={clickMenu("contacts")}>Contacts</a></li>
                <li><a href="#"
                    classList={{ active: props.page === "files"}}
                    onClick={clickMenu("files")}>Fichiers</a></li>
                <hr/>
                <li><a href="#"
                    classList={{ active: props.page === "values"}}
                    onClick={clickMenu("values")}>Valeurs</a></li>
                <hr/>
                <li><a href="#" onClick={disconnect}>Déconnexion</a></li>
            </ul>
        </div>
    </section>;
}
